import { render, staticRenderFns } from "./Other.vue?vue&type=template&id=4d90f1e0&scoped=true&"
import script from "./Other.vue?vue&type=script&lang=js&"
export * from "./Other.vue?vue&type=script&lang=js&"
import style0 from "./Other.vue?vue&type=style&index=0&id=4d90f1e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d90f1e0",
  null
  
)

export default component.exports